import { createSlice } from "@reduxjs/toolkit";

const STORAGE_KEY = "pos.heldOrders.v1";

const safeRead = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const safeWrite = (orders) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(orders));
  } catch {
    // ignore
  }
};

const initialState = {
  orders: safeRead(),
};

const heldOrdersSlice = createSlice({
  name: "heldOrders",
  initialState,
  reducers: {
    holdOrder: (state, action) => {
      const next = action.payload;
      if (!next?.id) return;

      state.orders = [next, ...state.orders.filter((o) => o?.id !== next.id)];
      safeWrite(state.orders);
    },
    removeHeldOrder: (state, action) => {
      const id = action.payload;
      state.orders = state.orders.filter((order) => order?.id !== id);
      safeWrite(state.orders);
    },
    clearHeldOrders: (state) => {
      state.orders = [];
      safeWrite(state.orders);
    },
  },
});

export const { holdOrder, removeHeldOrder, clearHeldOrders } =
  heldOrdersSlice.actions;
export default heldOrdersSlice.reducer;

